<template>
  <div v-if="allowedWorkspace">
    <Header />

    <WaitPayment v-if="subscriptionStatus === 'Subscription created'" />
    <NotPaid v-if="userHasWorkSpaces && subscriptionStatus === 'No Subscription'" isAdmin="isAdmin" />

    <div v-if="subscriptionStatus === 'Paid' || subscriptionStatus === 'Cancel at period end'">
      <div class="pageTitle">
        Retros
        <button
          type="button"
          @click="
            () => {
              activeModal.unshift('newRetro');
            }
          "
          class="button button_ok button_startRetro"
        >
          Start Retro
        </button>
      </div>

      <div v-bind:class="[workspaceLoaded ? '' : 'loading', noWorkspaces ? 'workspaceEmpty' : '', 'whiteBox whiteBoxWorkspace']">
        <div  v-if="workspaceLoaded && !noWorkspaces" :class="{
          'whiteBoxWorkspace_table-wrapper':true,
          'allowLastBottom':workspaceRetrosPaginated.length>3,
          'allowPreLastBottom':workspaceRetrosPaginated.length>4
        }">
          <table v-if="workspaceLoaded && !noWorkspaces && members">
            <thead>
            <tr>
              <th>Name</th>
              <th>Date</th>
              <th>Participants</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="retro in workspaceRetrosPaginated" :key="retro.id">
              <th @click="$router.push(`/${currentWorkspace.id}/${retro.id}`)">
                {{ retro.retroName || 'Untitled Retro' }}
              </th>
              <th @click="$router.push(`/${currentWorkspace.id}/${retro.id}`)">
                {{ retro.createdDate && formattedData(retro.createdDate.seconds)  }}
              </th>
              <th @click="$router.push(`/${currentWorkspace.id}/${retro.id}`)">
                <div v-for="participant in retro.participants"
                     v-bind:key="participant"
                     class="profileAvatar"
                     v-bind:style="{ backgroundImage: `url(${members[participant] && members[participant].photoURL || ''})` }"
                >
                  {{members[participant] && !members[participant].photoURL ? String(members[participant].name).substring(0,1) : ''}}
                </div>
              </th>
              <th>
                <div class="retros_submenu">
                  <div class="retros_submenu_dots">...</div>
                  <div class="submenu">
                    <a target="_blank" :href="'/' + currentWorkspace.id + '/' + retro.id">Open</a>
                    <button v-if="isAdmin" @click="deleteRetro(retro.id)">Delete</button>
                  </div>
                </div>
              </th>
            </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-if="totalPages>1"
          :page-count="totalPages"
          :click-handler="clickPaginationHandle"
          :prev-text="'Prev'"
          :next-text="'Next'"
          prev-class="pagination-prev"
          next-class="pagination-next"
          :container-class="'pagination'">
        </paginate>

        <template v-if="workspaceLoaded && noWorkspaces">
          <img src="~images/nothing-to-see-here.png" alt="" />
          <div class="workspaceEmpty_text">Nothing to see here</div>
        </template>
      </div>
    </div>

    <div class="popup_shadow" @click="hideFirstModal" v-if="activeModal.length"></div>

    <Popup v-if="activeModal[0] === 'newRetro'" title="New Retro">
      <template v-slot:fields>
        <label>Template</label>
        <div class="selectWrapper">
          <select v-model="selectedNewRetroTemplateId">
            <option v-for="template in newRetroTemplates" :key="template.index" :value="template.id">
              {{ template.name }}
            </option>
          </select>
        </div>
        <!--          <input v-model="displayName" type="text"  @keyup="()=>{error.displayName=''}"/>-->
        <!--          <div v-if="error.displayName !== ''" class="error-msg">-->
        <!--              {{ error.displayName }}-->
        <!--          </div>-->
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button v-bind:class="[loading.newRetro ? 'loading loading-center' : '', 'button button_ok']" @click="createNewRetro">Start Retro</button>
      </template>
    </Popup>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import db from 'src/firebase-config';
import Popup from '../elements/Popup.vue';
import Header from '../elements/Header.vue';
import WaitPayment from '../elements/WaitPayment.vue';
import NotPaid from '../elements/NotPaid.vue';
import firebase from 'firebase';
import mixins from 'src/mixins.js';
import _get from 'lodash.get';
import { ANALYTICS } from 'src/firebase-config';

export default {
  components: { Popup, Header, WaitPayment, NotPaid },
  mixins: [mixins],
  data() {
    return {
      currentPage:1,
      linesPerPage:10,
      retros: [],
      allowedWorkspace: false,
      retrosSubmenuOpened: '',
      selectedNewRetroTemplateId: 0,
      newRetroTemplates: [
        {
          id: 0,
          name:'Went Well - To Improve - Action Items',
          topicTitles: {
            '0':{
              id:'0',
              title:'Went Well',
              allowVote:true
            },
            '1':{
              id:'1',
              title:'To Improve',
              allowVote:true
            },
            '2':{
              id:'2',
              title:'Action Items',
              allowVote:false
            }
          }
        },
        {
          id: 1,
          name:'Start - Stop - Continue',
          topicTitles: {
            '0':{
              id:'0',
              title:'Start',
              allowVote:true
            },
            '1':{
              id:'1',
              title:'Stop',
              allowVote:true
            },
            '2':{
              id:'2',
              title:'Continue',
              allowVote:true
            }
          }
        }
      ],
      loading: {
        newRetro: false
      }
    };
  },
  computed: {
    ...mapState(['members','userInfo', 'userInfoLoaded', 'currentUser', 'workspaceRetros', 'workspaceLoaded', 'workspaces', 'currentWorkspace', 'userLoaded', 'isAdmin']),
    userVerified: function () {
      return this.currentUser && this.currentUser.emailVerified;
    },
    subscriptionStatus: function () {
      return _get(this.currentWorkspace, 'billing.subscriptionStatus', null);
    },
    retrosCollectionRef: function () {
      return db.collection('workspaces').doc(this.currentWorkspace.id).collection('retros');
    },
    noWorkspaces: function () {
      return this.workspaceRetros.length === 0;
    },
    isUserHasNoWorkspaces: function () {
      return this.allWorkspaces.length === 0;
    },
    userHasWorkSpaces: function () {
      return !this.isUserHasNoWorkspaces;
    },
    workspaceRetrosPaginated: function () {
      return this.workspaceRetros.slice((this.currentPage-1)*this.linesPerPage,(this.currentPage-1)*this.linesPerPage+this.linesPerPage);
    },
    totalPages: function () {
      return this.workspaceRetros.length/this.linesPerPage;
    }
  },
  methods: {
    createNewRetro() {
      const retroTemplate = this.newRetroTemplates[this.selectedNewRetroTemplateId];
      if (!retroTemplate) return;
      const create = () => {
        const newRetroId = this.generateId4();
        this.retrosCollectionRef
          .doc(newRetroId)
          .get()
          .then((doc) => {
            if (!doc.exists) {
              this.retrosCollectionRef
                .doc(newRetroId)
                .set({
                  retroName: '',
                  createdDate: firebase.firestore.FieldValue.serverTimestamp(),
                  topicMap: retroTemplate.topicTitles
                })
                .then(() => {
                  ANALYTICS.logEvent('retro_created',{
                    retroId: newRetroId
                  });
                  this.$store.commit('setWorkspaceDataLoaded', false);
                  this.$store.dispatch('getWorkspaceRetros', { workspaceId: this.currentWorkspace.id }).then(() => {
                    this.$store.commit('setWorkspaceDataLoaded', true);
                    this.hideFirstModal();
                  });

                  this.$router.push(`/${this.currentWorkspace.id}/${newRetroId}`)
                });
            } else {
              create();
            }
          });
      };
      create();
    },
    deleteRetro(id) {
      this.$store.commit('setWorkspaceDataLoaded', false);
      this.retrosCollectionRef
        .doc(id)
        .delete()
        .then(() => {
          this.$store.dispatch('getWorkspaceRetros', { workspaceId: this.currentWorkspace.id }).then(() => {
            this.$store.commit('setWorkspaceDataLoaded', true);
          });

          ANALYTICS.logEvent('retro_deleted',{
            retroId: id,
          });
        });
    },
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin();
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin();
    },
    clickPaginationHandle: function (pageNum) {
      this.currentPage=pageNum;
    }
  },
  mounted() {
    if(!this.currentUser){
        this.$router.push('/404');
    }
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
</style>
